<h1 class="d-none">Kachiing Giveaway</h1>
<div class="giveaway">
  <div class="container">
    <div class="giveaway-grid">
      <ng-container *ngFor="let item of giveaways; let index = index">
        <div class="giveaway__card">
          <img loading="lazy" [class.ended]="item.hasExpired" (click)="openGiveawayModal(giveawayModal, item)"
            src="{{ imgUrl }}{{ item.activeImage }}" />
          <div class="giveaway__card--body" (click)="openGiveawayModal(giveawayModal, item)">
            <div>
              <div class="title" [innerHTML]="item.title || 'No Title'"></div>
              <div class="participants">
                <span>{{ item.participants }}/{{ item.participantLimit }} Participants</span>
                <div class="images">
                  <ng-container *ngFor="let img of item.giveaway_participants; let i = index">
                    <ng-container *ngIf="i < 6">
                      <img loading="lazy" src="{{ local.checkImageProfile(img.appUser) }}"
                        (error)="commonService.handleErrorAvatar($event)" alt="" />
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="item.giveaway_participants.length > 6">
                    <div class="more">+{{ item.giveaway_participants.length - 6 }}</div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div>
              <div class="d-flex justify-content-between">
                <div class="text-muted item mt-auto"><i class="fa-solid fa-globe"></i> {{ item.subRegionName != "" ?
                  item.subRegionName : "All Region" }}</div>
                <div class="giveaway__card--buttons">
                  @if(item.hasExpired) {
                  <div class="participat text-danger">
                    <i class="fa-solid fa-times"></i>
                    Ended
                  </div>
                  }@else {
                  <div class="participat" *ngIf="item.hasParticipate; else joinContent"><i
                      class="fa-solid fa-check-square"></i> Participated</div>
                  <ng-template #joinContent>
                    <div class="item"><i class="fa-regular fa-hand-point-up"></i> Join</div>
                  </ng-template>
                  }
                </div>
              </div>
              <div class="giveaway__card--buttons">
                <div class="time my-auto">{{ item.remainingTime }}</div>
                <div class="actions">
                  <div class="copy-link" (click)="copyLink('giveaway', item)">
                    <i class="fa-solid fa-link"></i>
                  </div>
                  <div class="likes" (click)="likeGiveaway(item.id, item)">
                    <span>{{ item.giveawayLikes?.length }}</span>
                    <i class="{{ hasCheckedGiveaway(item.giveawayLikes) ? 'fa-solid' : 'fa-regular' }} fa-heart"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- <app-swiper></app-swiper> -->
<ng-template #giveawayModal let-modal>
  <div class="my-modal__close" (click)="modal.dismiss('Cross click')">
    <i class="fa-solid fa-times"></i>
  </div>
  <div id="giveaway_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-body">
      <!-- <span data-toggle="tooltip" *ngIf="giveaway.hasSurveys" data-placement="top" title="Survey" class="survey-toggle"
        data-delay="0" (click)="giveaway.showSurvey = true">
        <i class="fa-solid fa-tasks"></i>
      </span> -->

      <!-- Giveaway Card -->
      <div class="card mb-3 border-0" *ngIf="!giveaway.showSurvey">
        <div class="card-header bg-white border-0 p-0">
          <div class="title">{{ giveaway.title }}</div>
        </div>
        <div class="grid-image">
          <div style="position: relative; overflow: hidden">
            <img loading="lazy" class="main-image" [src]="imgUrl + activeImage"
              (error)="commonService.handleError($event)" />

            <div class="buttons">
              @if(giveaway.hasExpired) {
              <button class="btn red"><i class="fa-solid fa-times"></i> Ended</button>
              } @else {

              <button class="btn green" *ngIf="giveaway.hasParticipate; else joinContentDetail"
                (click)="handleParticipate(giveaway, true, true)" [disabled]="isLoading"><i
                  class="fa-solid fa-check-square"></i> Participated</button>
              <ng-template #joinContentDetail>
                <div class="timer">
                  @if(giveaway.moreThan1Day) {
                  <span class="box px-2 smaller">{{ giveaway.remainingTime }} Left!</span>
                  } @else if(giveaway.endDate) {
                  <span class="box">{{ giveaway.remainingTime[0] }}{{ giveaway.remainingTime[1] }}</span>
                  <span class="box-separate">:</span>
                  <span class="box">{{ giveaway.remainingTime[3] }}{{ giveaway.remainingTime[4] }}</span>
                  <span class="box-separate">:</span>
                  <span class="box">{{ giveaway.remainingTime[6] }}{{ giveaway.remainingTime[7] }}</span>
                  } @else {
                  <span class="box">{{ giveaway.participants - giveaway.participantLimit }} Left!</span>
                  }
                </div>
              </ng-template>
              }
            </div>
          </div>

          <div class="slide-images">
            <ng-container *ngFor="let image of giveaway.images">
              <div *ngIf="image != ''" (click)="changeShowImageProduct(image)"
                (error)="commonService.handleError($event)"
                [ngStyle]="{ 'background-image': 'url(' + imgUrl + image + ')' }"></div>
            </ng-container>
          </div>
        </div>

        <div class="card-footer bg-white border-0">
          <div class="d-flex justify-content-between">
            <div class="participants">
              <span>{{ giveaway.participants }}/{{ giveaway.participantLimit }} Participants</span>
              <div class="images">
                <ng-container *ngFor="let img of giveaway.giveaway_participants; let i = index">
                  <ng-container *ngIf="i < 6">
                    <img loading="lazy" src="{{ local.checkImageProfile(img.appUser) }}"
                      (error)="commonService.handleErrorAvatar($event)" alt="" />
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="giveaway.giveaway_participants.length > 6">
                  <div class="more">+{{ giveaway.giveaway_participants.length - 6 }}</div>
                </ng-container>
              </div>
            </div>
            <div class="d-flex mb-auto">
              <!-- [class.pink]="!appUserId" -->
              <button class="btn purple glow-notification"
                (click)="handleParticipate(giveaway, true, giveaway.hasParticipate)" [disabled]="isLoading"><i
                  class="fa-regular fa-{{ giveaway.hasParticipate ? 'check-square' : 'hand-point-up' }}"></i> {{
                giveaway.hasParticipate ? 'Participated' : 'Join' }}</button>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-muted item"><i class="fa-solid fa-globe"></i> {{ giveaway.subRegionName != "" ?
              giveaway.subRegionName : "All Region" }}</div>
            <div class="actions p-0">
              <div class="copy-link p-0" (click)="copyLink('giveaway', giveaway)">
                <i class="fa-solid fa-link"></i>
              </div>
              <div class="copy-link p-0" (click)="share(giveaway)">
                <i class="fa-solid fa-share"></i>
              </div>
              <div class="likes" (click)="likeGiveaway(giveaway.id, giveaway)">
                <span>{{ giveaway.giveawayLikes?.length }}</span>
                <i class="{{ hasCheckedGiveaway(giveaway.giveawayLikes) ? 'fa-solid' : 'fa-regular' }} fa-heart"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ng-container *ngIf="giveaway.showSurvey">
        <app-giveaway-survey [giveaway]="giveaway"></app-giveaway-survey>
      </ng-container>
      <app-my-tabs [tabs]="tabs" [defaultTabIndex]="1">
        <div tab0>
          <div class="desc px-3" *ngIf="!giveaway.showSurvey" [innerHTML]="giveaway.description"></div>
        </div>
        <div tab1>
          <div class="winner-list bg-white p-3 rounded shadow-sm" *ngIf="giveaway.hasExpired">
            <ul class="list-group list-group-flush">
              <ng-container *ngIf="giveaway.winner">
                <div class="text-center border-0 p-4">
                  <img height="200px" src="../../../../assets/images/new/giveaway/winner.gif" />
                  <h2 class="card-title fw-bold text-secondary">Congratulations!</h2>
                </div>
                <li *ngIf="giveaway.winner.isWinner"
                  class="list-group-item d-flex justify-content-between align-items-center">
                  <div class="d-flex gap-2">
                    <img loading="lazy" src="{{ local.checkImageProfile(giveaway.winner.appUser) }}" width="80px"
                      class="rounded-circle mr-3" alt="" />
                    <div class="my-auto">
                      <h5>{{ giveaway.winner.appUser?.profileCharacterName }}</h5>
                      <span>****{{ giveaway.winner.appUser?.phone?.toString().substr(4, 4) }}</span>
                    </div>
                  </div>
                  <span class="badge badge-winner">Winner</span>
                </li>
              </ng-container>
            </ul>
            <ng-container *ngIf="!giveaway.haveWinner">
              <div class="text-center border-0 p-4">
                <img src="../../../../assets/images/new/giveaway/searching.gif" />
                <h2 class="card-title fw-bold text-secondary">Prize Winner will be Drawn Soon!</h2>
              </div>
            </ng-container>
          </div>
        </div>
      </app-my-tabs>

      <!-- Winner List Sidebar -->
    </div>
  </div>
</ng-template>
<app-verify-email-popup #VerifEmailPopup></app-verify-email-popup>